import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "../features/profile/profile-page";
import { Require } from "../features/require";

export const Route = createFileRoute("/more/profile")({ component: Page });

function Page() {
	return (
		<Require permission="settings.manage">
			<ProfilePage />
		</Require>
	);
}
